export default __webpack_public_path__ + "static/media/HeadacheBasics.7cde0413.pdf";